import { IonCard } from "@ionic/react";

import Icon from "@components/text/Icon";
import styles from "@components/typography/Typography.module.css";
import { Colors } from "@utils/colorUtils";
import { IconName } from "@utils/iconUtils";

type Props = {
  color: Colors;
  icon: IconName;
};

const IconBlock = ({ color, icon }: Props) => (
  <IonCard className={styles.iconBlock} color={color}>
    <Icon color="white" icon={icon} />
  </IonCard>
);

export default IconBlock;
